import React, { useEffect, useMemo, useRef, useState } from "react";
import PropTypes from "prop-types";
import _ from "lodash";
import { InputAdornment, TextField } from "@mui/material";
import { styled } from "@mui/material/styles";
import SearchIcon from "@mui/icons-material/Search";

const PREFIX = "ServerSearch";

const classes = {
  searchField: `${PREFIX}-searchField`,
};

export const StyledTextField = styled(TextField)(({ theme }) => ({
  marginBottom: theme.shape.padding,
  [`& .${classes.searchField}`]: {
    borderRadius: theme.shape.borderRadius,
    backgroundColor: theme.palette.background.paper,
  },
}));

const ServerSearch = ({ controlInterface, controls }) => {
  const searchControl = useMemo(() => {
    return Object.values(controls).find((c) => c.field === "search");
  }, [controls]);

  const [inputValue, setInputValue] = useState("");

  useEffect(() => {
    setInputValue(searchControl?.value || "");
  }, [searchControl]);

  // Create a stable debounced function
  const debouncedUpdate = useRef(
    _.debounce((newValue, currentControls, currentInterface) => {
      const existing = Object.values(currentControls).find(
        (c) => c.field === "search"
      );
      if (newValue && newValue !== "") {
        currentInterface.addOrUpdate({
          field: "search",
          value: newValue,
          uuid: existing?.uuid,
        });
      } else {
        currentInterface.remove(existing?.uuid);
      }
    }, 500)
  ).current;

  const handleChange = (event) => {
    const newValue = event.target.value;
    // Update local state immediately
    setInputValue(newValue);
    // But debounce expensive operation
    debouncedUpdate(newValue, controls, controlInterface);
  };

  return (
    <StyledTextField
      className={classes.searchField}
      onChange={handleChange}
      InputProps={{
        id: "simpleTableSearch",
        startAdornment: (
          <InputAdornment position="start">
            <SearchIcon />
          </InputAdornment>
        ),
      }}
      value={inputValue}
    />
  );
};

ServerSearch.propTypes = {
  controlInterface: PropTypes.object.isRequired,
  controls: PropTypes.object.isRequired,
};

export default ServerSearch;
